import type { FC } from 'react';
import React from 'react';
import type { IIconProps } from '@/Module/Icon/Model';
import { BaseIcon } from './BaseIcon';
export const IconAccept: FC<IIconProps> = props => {
  return <BaseIcon {...props} data-sentry-element="BaseIcon" data-sentry-component="IconAccept" data-sentry-source-file="IconAccept.tsx">
      <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 64 64" width="64px" height="64px" fill="currentColor" data-sentry-element="svg" data-sentry-source-file="IconAccept.tsx">
        <path d="M32,6C17.641,6,6,17.641,6,32c0,14.359,11.641,26,26,26s26-11.641,26-26C58,17.641,46.359,6,32,6z M29,42L18,31l2-3l9,6 l13.957-12L46,25L29,42z" data-sentry-element="path" data-sentry-source-file="IconAccept.tsx" />
      </svg>
    </BaseIcon>;
};